module.exports = __webpack_public_path__ + "0fbbb52b0b23d9287535b0a4a2eba8dd.jpg";